import React from 'react';

interface ServiceItem {
  title: string;
  image: string;
  description: string[];
  link: string;
}

const services: ServiceItem[] = [
  {
    title: 'Architectural Metalwork',
    image: '/home/assets/img/services/ser6.jpg',
    description: [
      'Specializing in staircases and railings, canopies, fences and gates, kitchen components, and bars for custom homes and businesses. We focus on solid construction and seamless on-site installation.',
    ],
    link: '/portfolio',
  },
  {
    title: 'Custom Products & Finishes',
    image: '/home/assets/img/services/ser5.jpg',
    description: [
      'Unique metal details for any design. We fabricate custom furniture, signage, metal screens, artwork, and sculptures. Whether you need raw steel, Corten, stainless, or aluminum, we can get the exact look you want.',
    ],
    link: '/portfolio',
  },
  {
    title: 'Shop Capabilities',
    image: '/home/assets/img/services/ser3.jpg',
    description: [
      'A fully equipped facility for any job. From delicate architectural work to heavy-duty industrial parts, we have the machinery to handle it. We use CNC cutting, 100-ton forming equipment, MIG/TIG/Stick welding and brazing, machining, and more. We build parts that last.',
    ],
    link: '/portfolio',
  },
  {
    title: 'Design & Planning',
    image: '/home/assets/img/services/ser4.jpg',
    description: [
      'We create detailed 3D models and shop drawings for your job. For complex parts, we offer in-house 3D printing and rapid prototyping, allowing you to verify the design before fabrication begins.',
    ],
    link: '/portfolio',
  },
];

function Description() {
  return (
    <section className="tc-about-description" style={{ padding: '80px 0', backgroundColor: '#f8f8f8' }}>
      <div className="container">
        <div className="row">
          {services.map((service, idx) => (
            <div key={idx} className="col-lg-3 col-md-6 mb-4">
              <div
                className="service-item"
                style={{
                  height: '100%',
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
                }}
              >
                {/* Image */}
                <div
                  style={{
                    width: '100%',
                    height: '200px',
                    overflow: 'hidden',
                  }}
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease',
                    }}
                  />
                </div>

                {/* Content */}
                <div style={{ padding: '24px' }}>
                  {/* Title */}
                  <h3
                    style={{
                      fontSize: '20px',
                      fontWeight: '600',
                      marginBottom: '12px',
                      lineHeight: '1.3',
                      color: '#1a1a1a',
                    }}
                  >
                    {service.title}
                  </h3>

                  {/* Description */}
                  {service.description.map((paragraph, index) => (
                    <p
                      key={index}
                      style={{
                        fontSize: '14px',
                        lineHeight: '1.7',
                        color: '#666',
                        margin: 0,
                      }}
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Description;
